import { Box, Stack, Typography } from '@mui/material'
import { OrderResponseDto } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { InfoIcon, useMinimalsTheme } from '@tom-ui/ui'

interface GeneralCargoOrderDetailPanelProps {
  row: { original: OrderResponseDto }
}

export const GeneralCargoOrderDetailPanel = ({ row }: GeneralCargoOrderDetailPanelProps) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const { handlingInstructions } = row.original

  const renderItem = (title: string, value?: string | number | null) => {
    if (value === undefined || value === null || value === '') return null
    return (
      <Stack minWidth={200} p={2}>
        <Typography variant='subtitle2'>{title}</Typography>
        <Typography variant='body2'>{value}</Typography>
      </Stack>
    )
  }

  return (
    <Box
      sx={{
        bgcolor: theme.palette.grey[100],
        borderTop: `1px solid ${theme.palette.divider}`,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack direction='row'>
        <Stack
          direction='row'
          p={3}
          sx={{
            left: 0,
            minWidth: 520,
            position: 'sticky',
            borderRight: `1px solid ${theme.palette.divider}`,
            bgcolor: theme.palette.grey[100],
          }}
        >
          <InfoIcon sx={{ mr: 1 }} />
          <Typography variant='subtitle2' fontWeight={600}>
            {t('additionalInformation', 'Additional information')}
          </Typography>
        </Stack>

        <Stack direction='column'>
          <Stack direction='row' flexWrap='wrap'>
            {renderItem(
              t('additionalHandlingInstructions', 'Additional instructions'),
              handlingInstructions,
            )}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}
